import { gql, useMutation, useQuery } from "@apollo/client";
import type { AccessGrant, AccessGrantVariables } from "./schema/AccessGrant";
import type { AccessGrants as AccessGrantsQuery } from "./schema/AccessGrants";
import type { CreateGrant, CreateGrantVariables } from "./schema/CreateGrant";
import type {
  CreateGrantWithApiKeyValue,
  CreateGrantWithApiKeyValueVariables
} from "./schema/CreateGrantWithApiKeyValue";
import type { RevokeGrant, RevokeGrantVariables } from "./schema/RevokeGrant";

export const queryAccessGrants = gql`
  query AccessGrants {
    grants {
      allGrants {
        apiKeyId
        createdAt
        createdBy {
          email
          name
          firstName
          lastName
        }
        id
        name
      }
    }
  }
`;

export const queryAccessGrant = gql`
  query AccessGrant($id: String!) {
    grants {
      grant(id: $id) {
        apiKeyId
        name
        createdBy {
          email
          name
          firstName
          lastName
        }
        createdAt
        id
      }
    }
  }
`;

export const mutationCreateGrant = gql`
  mutation CreateGrant($name: String!, $apiKeyId: String!) {
    grants {
      createGrant(name: $name, apiKeyId: $apiKeyId) {
        token
        id
        name
      }
    }
  }
`;

export const mutationCreateGrantWithApiKeyValue = gql`
  mutation CreateGrantWithApiKeyValue($name: String!, $apiKeyValue: String!) {
    grants {
      createGrantWithApiKeyValue(name: $name, apiKeyValue: $apiKeyValue) {
        id
        name
        token
      }
    }
  }
`;

export const mutationRevokeGrant = gql`
  mutation RevokeGrant($id: String!) {
    grants {
      revokeGrant(id: $id)
    }
  }
`;

export function useAccessGrants() {
  return useQuery<AccessGrantsQuery>(queryAccessGrants, {
    fetchPolicy: "network-only"
  });
}

export function useAccessGrant(id: string) {
  return useQuery<AccessGrant, AccessGrantVariables>(queryAccessGrant, {
    variables: { id },
    fetchPolicy: "network-only"
  });
}

export function useCreateGrant() {
  return useMutation<CreateGrant, CreateGrantVariables>(mutationCreateGrant);
}

export function useCreateGrantWithApiKeyValue() {
  return useMutation<
    CreateGrantWithApiKeyValue,
    CreateGrantWithApiKeyValueVariables
  >(mutationCreateGrantWithApiKeyValue);
}

export function useRevokeGrant() {
  return useMutation<RevokeGrant, RevokeGrantVariables>(mutationRevokeGrant, {
    refetchQueries: [{ query: queryAccessGrants }]
  });
}
